import { ViewerCommand } from './ViewerCommand';
import { Vector3 } from 'three';
import { ViewerEvents } from '../../Viewer';
export class SetPositionCommand extends ViewerCommand {
    constructor(viewer, objects, newPositions, optionalOldPositions) {
        var _a;
        super(viewer, objects);
        this.type = 'SetPositionCommand';
        this.name = this.composeName();
        this.updatable = true;
        this.newPositions = newPositions.map((position) => position.clone());
        this.oldPositions = (_a = optionalOldPositions === null || optionalOldPositions === void 0 ? void 0 : optionalOldPositions.map((position) => position.clone())) !== null && _a !== void 0 ? _a : objects.map((object) => object.position.clone());
    }
    execute() {
        this.objects.forEach((object, index) => {
            object.position.copy(this.newPositions[index]);
            object.updateMatrixWorld(true);
        });
        this.viewer.emit(ViewerEvents.SetObjectsPosition, this.objects.map((object) => object.uuid));
    }
    undo() {
        this.objects.forEach((object, index) => {
            object.position.copy(this.oldPositions[index]);
            object.updateMatrixWorld(true);
        });
        this.viewer.emit(ViewerEvents.SetObjectsPosition, this.objects.map((object) => object.uuid));
    }
    update(cmd) {
        if (this.newPositions.length !== cmd.newPositions.length) {
            throw Error(`Invalid update of ${this.type}. newPositions member must have equal length`);
        }
        this.newPositions.forEach((position, index) => position.copy(cmd.newPositions[index]));
    }
    toJSON() {
        const output = super.toJSON();
        output.newPositions = this.newPositions.map((position) => position.toArray());
        output.oldPositions = this.oldPositions.map((position) => position.toArray());
        return output;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.oldPositions = json.oldPositions.map((position) => new Vector3().fromArray(position));
        this.newPositions = json.newPositions.map((position) => new Vector3().fromArray(position));
    }
}
